import axios from '../request/http.js'

class Role {
  /* 一级管理员下的角色 */
  static getOneLevelRoleList() {
    let url = `/zzd/api/back/super/admin/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 二级管理员下的角色 */
  static getTwoLevelRoleList() {
    const url = `/zzd/api/back/biz/role/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取一级管理员下的二级角色用户列表 */
  static getOneLevelRoleAuthorityList(name, currentPage) {
    const url = `/zzd/api/back/super/admin/user/list?name=${name}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取二级管理员下的二级角色用户列表 */
  static getTwoLevelRoleAuthorityList(type, roleId, name, currentPage) {
    const url = `/zzd/api/back/biz/role/user/list?type=${type}&roleId=${roleId}&name=${name}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 一级添加二级管理员 */
  static postAddOneLevelRoleAuthority(data) {
    const url = `/zzd/api/back/super/admin/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 二级管理员添加角色 */
  static postAddTwoLevelRoleAuthority(data) {
    const url = `/zzd/api/back/biz/role/user/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 一级删除二级管理员 */
  static postDelOneLevelRoleAuthority(data) {
    const url = `/zzd/api/back/super/admin/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 二级管理员删除角色 */
  static postDelTwoLevelRoleAuthority(data) {
    const url = `/zzd/api/back/biz/role/user/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 添加角色用户管理范围 */
  static postControl(data) {
    const url = `/zzd/api/back/biz/role/user/authority/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  
  /* 设置管理单据范围 */
  static postSetBill(data) {
    const url = `/zzd/api/back/biz/role/set/cashier/reimbursementType`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Role;